<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Código de la Carrera">
        <b-form-input
          v-model="form.codigo"
          placeholder="Ej: ISC"
          required
          maxlength="10"
        />
      </b-form-group>

      <b-form-group label="Nombre de la Carrera" class="mt-1">
        <b-form-input
          v-model="form.nombre"
          placeholder="Ej: Ingeniería en Sistemas Computacionales"
          required
          maxlength="200"
        />
      </b-form-group>

      <b-form-group label="Facultad" class="mt-1">
        <b-form-select
          v-model="form.facultadId"
          :options="facultyOptions"
          required
        />
      </b-form-group>

      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect } from 'bootstrap-vue'
import facultadesService from '@/services/facultadesService'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  props: {
    programData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalId: 'program-modal',
      form: {
        carreraId: null,
        codigo: '',
        nombre: '',
        facultadId: null,
        estado: true,
      },
      faculties: [],
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.carreraId ? 'Editar Carrera' : 'Nueva Carrera'
    },
    facultyOptions() {
      return [
        { text: 'Seleccione una facultad', value: null },
        ...this.faculties.map(faculty => ({
          text: faculty.nombre,
          value: faculty.facultadId
        }))
      ]
    },
  },
  async mounted() {
    await this.loadFaculties()
  },
  watch: {
    programData(newData) {
      if (newData) {
        this.form = { ...newData }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    async loadFaculties() {
      try {
        const response = await facultadesService.getAll()
        this.faculties = response.data
      } catch (error) {
        console.error('Error al cargar facultades:', error)
      }
    },
    handleSubmit() {
      this.$emit('submit', { ...this.form })
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        carreraId: null,
        codigo: '',
        nombre: '',
        facultadId: null,
        estado: true,
      }
    },
  },
}
</script>
